<template>
	<div class="tb-order-page">
		<div class="btnbox">
			<el-button type="primary" size="small" :disabled="downloading" @click="onOpenDownload">下载售后订单</el-button>
		</div>

		<section class="filter-card">
			<el-form v-show="filtershow" :model="form" inline size="small" class="filter-form" label-width="0" @submit.native.prevent="onSearch">
				<div class="filter-row">
					<el-form-item>
						<el-select
							v-model="form.shop_id"
							placeholder="店铺"
							filterable
							clearable
							:loading="shopLoading"
							class="filter-control"
						>
							<el-option label="全部" value="" />
							<el-option
								v-for="item in shopList"
								:key="item.id"
								:label="shopLabel(item)"
								:value="String(item.id)"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-input v-model="form.order_sn" placeholder="订单号" clearable class="filter-control" @keyup.enter.native="onSearch" />
					</el-form-item>
					<el-form-item>
						<el-input v-model="form.after_sale_id" placeholder="退款单号" clearable class="filter-control" @keyup.enter.native="onSearch" />
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.after_sales_status" placeholder="售后状态" clearable class="filter-control filter-control--wide">
							<el-option label="售后状态" value="" />
							<el-option
								v-for="item in afterSalesStatusOptions"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.after_sales_type" placeholder="售后类型" clearable class="filter-control">
							<el-option label="售后类型" value="" />
							<el-option
								v-for="item in afterSalesTypeOptions"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.platform_order_status" placeholder="平台订单状态" clearable class="filter-control">
							<el-option label="平台订单状态" value="" />
							<el-option
								v-for="item in platformOrderStatusOptions"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							/>
						</el-select>
					</el-form-item>
					<div class="filter-actions">
						<el-button type="primary" class="btn-search" @click="onSearch">查询</el-button>
						<el-button class="btn-ghost" @click="onReset">重置</el-button>
					</div>
				</div>
			</el-form>
			<div class="filter-toggle" @click="toggleFilter">{{ filtershow ? '收起' : '展开' }}</div>
		</section>

		<el-alert
			v-if="listError"
			:title="listError"
			type="warning"
			show-icon
			:closable="false"
		/>

		<section class="table-card" ref="tableCard">
			<el-table
				v-loading="loading"
				:data="list"
				:height="tableHeight"
				border
				class="order-table"
			>
				<el-table-column label="店铺名称" align="center" header-align="center" min-width="120">
					<template slot-scope="scope">{{ displayCell(scope.row.mall_name || scope.row.retail_shop_name) }}</template>
				</el-table-column>
				<el-table-column label="退款单号" align="center" header-align="center" min-width="140">
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.after_sale_id) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单编号" align="center" header-align="center" min-width="160">
					<template slot-scope="scope">
						<div class="order-sn-text">{{ displayCell(scope.row.order_sn) }}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="售后状态"
					align="center"
					header-align="center"
					min-width="160"
					class-name="adapt-text-column"
				>
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.after_sales_status_str) }}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="售后类型"
					align="center"
					header-align="center"
					min-width="90"
					class-name="adapt-text-column"
				>
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.after_sales_type_str) }}</div>
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					header-align="center"
					min-width="56"
					class-name="platform-order-status-column"
				>
					<template slot="header">
						<div class="header-wrap-3">平台订单状态</div>
					</template>
					<template slot-scope="scope">{{ displayCell(scope.row.order_status_str) }}</template>
				</el-table-column>
				<el-table-column label="平台售后状态" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.order_service_status_str) }}</template>
				</el-table-column>
				<el-table-column label="纠纷类型" align="center" header-align="center" min-width="80">
					<template slot-scope="scope">{{ displayCell(scope.row.dispute_refund_status) }}</template>
				</el-table-column>
				<el-table-column label="极速退款" align="center" header-align="center" min-width="80">
					<template slot-scope="scope">{{ displayCell(scope.row.speed_refund_flag) }}</template>
				</el-table-column>
				<el-table-column label="收货状态" align="center" header-align="center" min-width="90">
					<template slot-scope="scope">{{ displayCell(scope.row.user_shipping_status) }}</template>
				</el-table-column>
				<el-table-column
					label="商品名称"
					align="center"
					header-align="center"
					width="226"
					class-name="goods-name-column"
				>
					<template slot-scope="scope">
						<el-popover
							v-if="scope.row.goods_name"
							trigger="hover"
							placement="top"
							width="360"
							popper-class="goods-name-popover"
						>
							<div class="goods-name-popover__content">{{ scope.row.goods_name }}</div>
							<el-button type="text" size="mini" @click="oncopy(scope.row.goods_name)">复制</el-button>
							<div slot="reference" class="goods-name-cell">{{ scope.row.goods_name }}</div>
						</el-popover>
						<span v-else class="goods-name-empty">-</span>
					</template>
				</el-table-column>
				<el-table-column label="商品数量" align="center" header-align="center" min-width="80">
					<template slot-scope="scope">{{ displayCell(scope.row.goods_number) }}</template>
				</el-table-column>
				<el-table-column label="商家外部编码（sku）" align="center" header-align="center" min-width="160">
					<template slot-scope="scope">{{ displayCell(scope.row.outer_id) }}</template>
				</el-table-column>
				<el-table-column label="订单金额（元）" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.order_amount) }}</template>
				</el-table-column>
				<el-table-column label="退款金额（元）" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.refund_amount) }}</template>
				</el-table-column>
				<el-table-column label="退货快递" align="center" header-align="center" min-width="100">
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.shipping_name) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="退货运单号" align="center" header-align="center" min-width="140">
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.tracking_number) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="售后创建时间" align="center" header-align="center" min-width="150">
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.create_time_str) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="更新时间" align="center" header-align="center" min-width="150">
					<template slot-scope="scope">
						<div class="adapt-text">{{ displayCell(scope.row.update_time_str) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" header-align="center" fixed="right" width="80">
					<template slot-scope="scope">
						<div class="operation_i">
							<div v-if="scope.row.trade_no">
								<span @click="onHandle(scope.row.trade_no)">去处理</span>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</section>

		<section class="pager-card">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[20, 30, 50]"
				:current-page.sync="page"
				:page-size.sync="pageSize"
				:total="total"
				@current-change="fetchList"
				@size-change="onPageSizeChange"
			/>
		</section>

		<el-dialog title="售后订单下载" :visible.sync="downloadVisible" width="650px" :before-close="onCloseDownload" :close-on-click-modal="false">
			<el-form v-if="downloadVisible" ref="downloadForm" :model="downloadForm" :rules="downloadRules" label-width="80px" size="small">
				<el-form-item label="店铺" prop="shop_id" class="item">
					<el-select v-model="downloadForm.shop_id" placeholder="请选择店铺" filterable>
						<el-option
							v-for="item in shopList"
							:key="item.id"
							:label="shopLabel(item)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="开始日期" class="item">
					<el-date-picker
						v-model="downloadForm.btime"
						type="date"
						placeholder="默认当天"
						value-format="yyyy-MM-dd"
						clearable
						:picker-options="btimePickerOptions"
					/>
				</el-form-item>
				<el-form-item label="结束日期" class="item">
					<el-date-picker
						v-model="downloadForm.etime"
						type="date"
						placeholder="默认当天"
						value-format="yyyy-MM-dd"
						clearable
						:picker-options="etimePickerOptions"
					/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCloseDownload">取消</el-button>
				<el-button type="primary" :loading="downloading" @click="onSubmitDownload">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getApiErrorMessage } from '@/constants/retailPlatform'
	import {
		TB_SHOP_API,
		TB_AFTER_SALE_API,
		getRequestErrorMessage,
	} from '@/constants/taobaoShop'

	export default {
		name: 'TaobaoService',
		inject: ['appdata', 'oncopy'],
		data() {
			return {
				shopList: [],
				shopLoading: false,
				list: [],
				loading: false,
				listError: '',
				page: 1,
				pageSize: 20,
				total: 0,
				tableHeight: 480,
				filtershow: true,
				downloading: false,
				downloadVisible: false,
				form: this.emptyForm(),
				downloadForm: this.emptyDownloadForm(),
				downloadRules: {
					shop_id: [{ required: true, message: '请选择店铺', trigger: 'change' }],
				},
			}
		},
		computed: {
			afterSalesStatusOptions() {
				return (this.appdata && this.appdata.list && this.appdata.list.tb_after_sales_status) || []
			},
			afterSalesTypeOptions() {
				return (this.appdata && this.appdata.list && this.appdata.list.tb_after_sales_type) || []
			},
			platformOrderStatusOptions() {
				return (this.appdata && this.appdata.list && this.appdata.list.order_status) || []
			},
			btimePickerOptions() {
				const etime = this.downloadForm.etime
				return {
					disabledDate: (time) => {
						if (time.getTime() > Date.now()) {
							return true
						}
						if (etime) {
							const t = this.$moment(etime)
							return time.getTime() > t.valueOf()
								|| time.getTime() < t.clone().subtract(15, 'days').valueOf()
						}
						return false
					},
				}
			},
			etimePickerOptions() {
				const btime = this.downloadForm.btime
				return {
					disabledDate: (time) => {
						if (time.getTime() > Date.now()) {
							return true
						}
						if (btime) {
							const t = this.$moment(btime)
							return time.getTime() < t.valueOf()
								|| time.getTime() > t.clone().add(15, 'days').valueOf()
						}
						return false
					},
				}
			},
		},
		mounted() {
			this.fetchShops()
			this.fetchList()
			this.$nextTick(this.calcTableHeight)
			window.addEventListener('resize', this.calcTableHeight)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calcTableHeight)
		},
		methods: {
			emptyForm() {
				return {
					shop_id: '',
					order_sn: '',
					after_sale_id: '',
					after_sales_status: '',
					after_sales_type: '',
					platform_order_status: '',
				}
			},
			emptyDownloadForm() {
				const today = this.$moment().format('YYYY-MM-DD')
				return {
					shop_id: '',
					btime: today,
					etime: today,
				}
			},
			shopLabel(item) {
				if (!item) {
					return ''
				}
				return item.shop_name || item.mall_name || ('店铺' + item.id)
			},
			displayCell(value) {
				if (value === 0) {
					return '0'
				}
				if (value == null || value === '') {
					return '-'
				}
				return String(value)
			},
			toggleFilter() {
				this.filtershow = !this.filtershow
				this.$nextTick(this.calcTableHeight)
			},
			calcTableHeight() {
				this.$nextTick(() => {
					const card = this.$refs.tableCard
					if (!card) {
						return
					}
					const h = card.getBoundingClientRect().height
					this.tableHeight = h > 280 ? Math.floor(h) : 280
				})
			},
			fetchShops() {
				this.shopLoading = true
				this.$axios.get(TB_SHOP_API.shopList).then((res) => {
					if (res.data.code == 0) {
						this.shopList = (res.data.data && res.data.data.list) || []
					} else {
						this.shopList = []
					}
				}).catch((err) => {
					console.log(err)
					this.shopList = []
				}).finally(() => {
					this.shopLoading = false
				})
			},
			buildListParams() {
				const params = {
					page: this.page,
					limit: this.pageSize,
				}
				if (this.form.shop_id) {
					params.shop_id = Number(this.form.shop_id)
				}
				const orderSn = String(this.form.order_sn || '').trim()
				if (orderSn) {
					params.order_sn = orderSn
				}
				const afterSaleId = String(this.form.after_sale_id || '').trim()
				if (afterSaleId) {
					params.after_sale_id = afterSaleId
				}
				if (this.form.after_sales_status) {
					params.after_sales_status = this.form.after_sales_status
				}
				if (this.form.after_sales_type) {
					params.after_sales_type = this.form.after_sales_type
				}
				if (this.form.platform_order_status !== '' && this.form.platform_order_status != null) {
					params.platform_order_status = this.form.platform_order_status
				}
				return params
			},
			fetchList() {
				this.loading = true
				this.listError = ''
				this.$axios.get(TB_AFTER_SALE_API.list, { params: this.buildListParams() }).then((res) => {
					if (res.data.code == 0) {
						const data = res.data.data || {}
						this.list = data.list || []
						this.total = Number(data.count != null ? data.count : data.total) || 0
						this.$nextTick(this.calcTableHeight)
					} else {
						this.list = []
						this.total = 0
						this.listError = getApiErrorMessage(res, '获取淘宝售后失败')
					}
				}).catch((err) => {
					console.log(err)
					this.list = []
					this.total = 0
					this.listError = getRequestErrorMessage(err, '获取淘宝售后失败')
				}).finally(() => {
					this.loading = false
				})
			},
			onSearch() {
				this.page = 1
				this.fetchList()
			},
			onReset() {
				this.form = this.emptyForm()
				this.page = 1
				this.fetchList()
			},
			onPageSizeChange(size) {
				this.page = 1
				this.pageSize = size
				this.fetchList()
			},
			onHandle(tradeNo) {
				const url = this.$router.resolve({
					path: '/buyer/order/order',
					query: { trade_no: tradeNo },
				})
				window.open(url.href, '_blank')
			},
			onOpenDownload() {
				const form = this.emptyDownloadForm()
				if (this.form.shop_id) {
					form.shop_id = Number(this.form.shop_id)
				} else if (this.shopList.length) {
					form.shop_id = this.shopList[0].id
				}
				this.downloadForm = form
				this.downloadVisible = true
				this.$nextTick(() => {
					if (this.$refs.downloadForm) {
						this.$refs.downloadForm.clearValidate()
					}
				})
			},
			onCloseDownload() {
				this.downloadVisible = false
			},
			onSubmitDownload() {
				this.$refs.downloadForm.validate((valid) => {
					if (!valid) {
						return
					}
					if (!this.downloadForm.btime || !this.downloadForm.etime) {
						this.$message.warning('请选择开始日期和结束日期')
						return
					}
					const diff = this.$moment(this.downloadForm.etime).diff(
						this.$moment(this.downloadForm.btime),
						'days'
					)
					if (diff < 0) {
						this.$message.warning('结束日期不能早于开始日期')
						return
					}
					if (diff > 15) {
						this.$message.warning('日期跨度不能超过15天')
						return
					}
					this.downloading = true
					this.$axios.post(TB_AFTER_SALE_API.download, {
						shop_id: this.downloadForm.shop_id,
						btime: this.downloadForm.btime,
						etime: this.downloadForm.etime,
					}).then((res) => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message || res.data.msg || '同步任务已提交，请稍后刷新列表')
							this.onCloseDownload()
							this.fetchList()
						} else {
							this.$message.error(getApiErrorMessage(res, '下载售后失败'))
						}
					}).catch((err) => {
						console.log(err)
						this.$message.error(getRequestErrorMessage(err, '下载售后失败'))
					}).finally(() => {
						this.downloading = false
					})
				})
			},
		},
	}
</script>

<style scoped lang="less">
	@import '../storeTable.less';

	.tb-order-page {
		height: 100%;
		min-height: calc(100vh - 62px);
		padding: 8px 12px 0;
		box-sizing: border-box;
		background: linear-gradient(180deg, #f7f9fc 0%, #f3f5f8 100%);
		overflow: hidden;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.filter-card,
	.table-card,
	.pager-card {
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
	}

	.filter-card {
		padding: 10px 14px 0;
		flex-shrink: 0;
	}

	.filter-toggle {
		padding: 6px 0 8px;
		text-align: center;
		font-size: 12px;
		color: #909399;
		cursor: pointer;
	}

	.filter-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px;
		width: 100%;
	}

	.filter-actions {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
	}

	.btn-search {
		background: linear-gradient(135deg, #ff6b3d 0%, #ff4714 100%) !important;
		border: none !important;
	}

	.btn-ghost {
		color: #606266;
		border-color: #e4e7ed;
		background: #fafbfc;
	}

	.filter-form {
		display: block;
		width: 100%;

		.filter-row > .el-form-item {
			margin-bottom: 0;
			margin-right: 0;
		}

		.filter-control {
			width: 160px;
		}

		.filter-control--wide {
			width: 220px;
		}
	}

	.btnbox {
		flex-shrink: 0;
		margin-bottom: 0;
	}

	.table-card {
		flex: 1;
		min-height: 0;
		padding: 0;
		overflow: hidden;
		.store-table-border();
	}

	.order-table {
		width: 100%;
	}

	.adapt-text {
		line-height: 1.35;
		word-break: break-all;
		white-space: normal;
	}

	.order-sn-text {
		line-height: 1.35;
		white-space: nowrap;
	}

	.header-wrap-3 {
		width: 3em;
		margin: 0 auto;
		line-height: 1.3;
		word-break: break-all;
		white-space: normal;
	}

	.goods-name-cell {
		width: 15em;
		margin: 0 auto;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
		cursor: pointer;
	}

	.goods-name-empty {
		color: #909399;
	}

	/deep/ td.adapt-text-column .cell,
	/deep/ td.goods-name-column .cell {
		white-space: normal;
	}

	/deep/ td.goods-name-column .cell {
		overflow: hidden;
	}

	/deep/ th.platform-order-status-column .cell,
	/deep/ td.platform-order-status-column .cell {
		white-space: normal;
		padding-left: 4px;
		padding-right: 4px;
	}

	/deep/ .item .el-select,
	/deep/ .item .el-date-editor {
		width: 300px;
	}

	.pager-card {
		flex-shrink: 0;
		padding: 6px 12px 8px;
		display: flex;
		justify-content: flex-end;
	}
</style>

<style lang="less">
.goods-name-popover__content {
	max-height: 200px;
	overflow-y: auto;
	word-break: break-all;
	line-height: 1.5;
	margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/taobao/service.vue